const useLoading = (cachingKey: string, isLoading = false) => {

  const loading: Ref<boolean> = useState(cachingKey, () => isLoading);
  const setLoading = (value: boolean) => {

    loading.value = value;
  
  };

  return {
    loading,
    setLoading,
  };

};
export default useLoading;
